module.exports = __webpack_public_path__ + "media/images/flavours/icon-alcool_dark-21c7b1a2a90dd5a2a0d7db9013eb8a77.png";